<template>
  <div class="tab-container">
    <app-spinner v-if="!is_page_loaded" />
    <template v-else>
      <template v-if="table_own.items.length">
        <v-client-table
          :data="table_own.items"
          :columns="table_own.columns"
          :options="table_own.options"
          class="table-default"
        >
          <template #count="{ row, index }">{{ index }}</template>
          <template #company>Altezza</template>
          <template #driver="{ row }">
            <div
              v-if="row.driver"
              class="status-tag"
              :style="{ 'backgroundColor': row.driver_confirmed ? '#77b017' : '#f0c427' }"
            >
              {{ row.driver.full_name }}
            </div>
            <div v-else class="status-tag" style="background-color: #e85c20">Not assigned</div>
          </template>
          <template #plate_number="{ row }">
            <app-cells position="center" gap="10px" :indent="false">
              <div class="status-tag" :style="{ 'backgroundColor': row.car_confirmed ? '#77b017' : '#f0c427' }">
                {{ row.car.plate_number }}
              </div>
              <img v-if="row.primary_car" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
            </app-cells>
          </template>
          <template #communication="{ row }">
            <div class="table-default__controls">
              <button
                v-if="row.driver"
                v-tooltip="{content: row.driver.phone, placement: 'top-start', offset: 10}"
                @click="onCopy(row.driver.phone)"
                class="table-default__activity table-default__activity--phone"
                :class="{'table-default__activity--active': row.driver.phone}"
              />
              <button v-else class="table-default__activity table-default__activity--phone" />
              <a
                v-if="row.driver"
                :href="`https://t.me/${row.driver.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--tg"
                :class="{'table-default__activity--active': row.driver.phone_telegram}"
              />
              <a v-else class="table-default__activity table-default__activity--tg" />
              <a
                v-if="row.driver"
                :href="`https://wa.me/${row.driver.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--wa"
                :class="{'table-default__activity--active': row.driver.phone_whatsapp}"
              />
              <a v-else class="table-default__activity table-default__activity--wa" />
            </div>
          </template>
        </v-client-table>
      </template>
      <template v-if="table_rental.items.length">
        <v-client-table
          :data="table_rental.items"
          :columns="table_rental.columns"
          :options="table_rental.options"
          class="table-default"
        >
          <template #count="{ row, index }">{{ index }}</template>
          <template #company="{ row }">{{ row.rental_company.name }}</template>
          <template #driver="{ row }">
            <div
              v-if="row.driver"
              class="status-tag"
              :style="{ 'backgroundColor': row.driver_confirmed ? '#77b017' : '#f0c427' }"
            >
              {{ row.driver.full_name }}
            </div>
            <div v-else class="status-tag" style="background-color: #e85c20">Not assigned</div>
          </template>
          <template #plate_number="{ row }">
            <app-cells position="center" gap="10px" :indent="false">
              <div class="status-tag" :style="{ 'backgroundColor': row.car_confirmed ? '#77b017' : '#f0c427' }">
                {{ row.car.plate_number }}
              </div>
              <img v-if="row.primary_car" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
            </app-cells>
          </template>
          <template #communication="{ row }">
            <div class="table-default__controls">
              <button
                v-if="row.driver"
                v-tooltip="{content: row.driver.phone, placement: 'top-start', offset: 10}"
                @click="onCopy(row.driver.phone)"
                class="table-default__activity table-default__activity--phone"
                :class="{'table-default__activity--active': row.driver.phone}"
              />
              <button v-else class="table-default__activity table-default__activity--phone" />
              <a
                v-if="row.driver"
                :href="`https://t.me/${row.driver.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--tg"
                :class="{'table-default__activity--active': row.driver.phone_telegram}"
              />
              <a v-else class="table-default__activity table-default__activity--tg" />
              <a
                v-if="row.driver"
                :href="`https://wa.me/${row.driver.phone}`"
                target="_blank"
                class="table-default__activity table-default__activity--wa"
                :class="{'table-default__activity--active': row.driver.phone_whatsapp}"
              />
              <a v-else class="table-default__activity table-default__activity--wa" />
            </div>
          </template>
        </v-client-table>
      </template>
      <app-no-results
        v-if="!table_own.items.length && !table_rental.items.length"
        text="There’s no bookings yet"
      />
    </template>
  </div>
</template>

<script>
import {
  getEmployeesList,
  getSafariDrivers,
  getSafariOwnCars,
  getSafariRentalCars,
  getSafariRentalCompany,
  getSafariGroupsCarsList,
  patchSafariGroupsCars, getReservationSafariCars,
} from '@/http'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'SafariGroupsDetailCars',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      is_page_loaded: false,
      table_own: {
        items: [],
        columns: ['count', 'company', 'plate_number', 'driver', 'communication'],
        options: {
          headings: {
            count: '#',
            company: 'Company',
            plate_number: 'Car',
            driver: 'Driver',
            communication: 'Communication'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_rental: {
        items: [],
        columns: ['count', 'company', 'plate_number', 'driver', 'communication'],
        options: {
          headings: {
            count: '#',
            company: 'Company',
            plate_number: 'Car',
            driver: 'Driver',
            communication: 'Communication',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },

    }
  },
  created() {
    this.fetchSafariCarsList()
  },
  methods: {
    fetchSafariCarsList() {
      getReservationSafariCars(this.groupDetail.reservation.id).then(response => {
        this.table_own.items = response.data.own_cars
        this.table_rental.items = response.data.rental_cars

        this.is_page_loaded = true
      })
    },
  }
}
</script>
